module.exports = __webpack_public_path__ + "static/img/repairs.1163304.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/repairs.png
// module id = GU92
// module chunks = 1